import React, { Component, Fragment } from 'react';
import { Table, Input, FormGroup, Label, Button, ButtonGroup } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faRetweet } from '@fortawesome/free-solid-svg-icons';
import { Spin, Empty } from 'antd';
import Paging from '../../components/paging';
import 'moment/locale/id';

export default class SearchCenter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keyword: '',
            currentPage: 0,
            paging: 15,
            pageCount: 0,
            activeTab: 'all',
            isLoading: false,
            initialLoad: true,
            dataSearch: {
                perusahaan: [],
                perusahaan_users: [],
                karyawan: []
            },
            error: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handlePaging = this.handlePaging.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentDidMount() {
        this.fetchAllData();
    }

    handleChange(event) {
        this.setState({
            keyword: event.target.value,
            currentPage: 0,
        });
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSearch();
        }
    }

    handleSearch() {
        if (this.state.keyword.length === 0 && this.state.initialLoad) {
            this.setState({
                isLoading: true,
                error: null,
                initialLoad: true
            }, this.fetchAllData);
            return;
        }


        this.setState({
            isLoading: true,
            error: null,
            initialLoad: false
        }, this.fetchSearchData);
    }

    fetchAllData = () => {
        const formData = {
            keyword: '',
            page: this.state.currentPage + 1,
            paging: this.state.paging,
            auth: this.props.auth,
        };

        this.props.request("admin/search/global-search", formData)
            .then(res => {
                if (res.success) {
                    this.setState({
                        dataSearch: {
                            perusahaan: res.data.perusahaan || [],
                            perusahaan_users: res.data.perusahaan_users || [],
                            karyawan: res.data.karyawan || []
                        },
                        pageCount: res.data.total_page || 0,
                        isLoading: false,
                        error: null
                    });
                } else {
                    this.setState({
                        dataSearch: {
                            perusahaan: [],
                            perusahaan_users: [],
                            karyawan: []
                        },
                        isLoading: false,
                        error: res.message || 'Gagal memuat data'
                    });
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    error: error.message || 'Terjadi kesalahan saat menghubungi server'
                });
            });
    };

    fetchSearchData = () => {
        const formData = {
            keyword: this.state.keyword,
            page: this.state.currentPage + 1,
            paging: this.state.paging,
            auth: this.props.auth,
        };

        this.props.request("admin/search/global-search", formData)
            .then(res => {
                if (res.success) {
                    this.setState({
                        dataSearch: {
                            perusahaan: res.data.perusahaan || [],
                            perusahaan_users: res.data.perusahaan_users || [],
                            karyawan: res.data.karyawan || []
                        },
                        pageCount: res.data.total_page || 0,
                        isLoading: false,
                        error: null
                    });
                } else {
                    this.setState({
                        dataSearch: {
                            perusahaan: [],
                            perusahaan_users: [],
                            karyawan: []
                        },
                        isLoading: false,
                        error: res.message || 'Gagal memuat data'
                    });
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    error: error.message || 'Terjadi kesalahan saat menghubungi server'
                });
            });
    };

    handleRefresh() {
        this.setState({
            keyword: '',
            currentPage: 0,
            initialLoad: true,
            isLoading: true,
            error: null
        }, this.fetchAllData);
    }

    handlePageClick(data) {
        const selected = data.selected;
        this.setState({ currentPage: selected }, () => {
            if (this.state.keyword.length > 0) {
                this.fetchSearchData();
            } else {
                this.fetchAllData();
            }
        });
    }

    handlePaging(event) {
        const value = parseInt(event.target.value);
        this.setState({
            paging: value,
            currentPage: 0
        }, () => {
            if (this.state.keyword.length > 0) {
                this.fetchSearchData();
            } else {
                this.fetchAllData();
            }
        });
    }

    renderResults(data, type) {
        const { currentPage, paging } = this.state;
        const offset = currentPage * paging;

        if (!data || data.length === 0) {
            return <div className="text-muted py-3">Tidak ada data {type}</div>;
        }

        return (
            <Table striped responsive>
                <thead className="thead-dark">
                <tr>
                    <th>#</th>
                    {type === 'perusahaan' && (
                        <>
                            <th>Nama</th>
                            <th>Email</th>
                            <th>Telepon</th>
                            <th>WA</th>
                            <th>Alamat</th>
                            <th>Bidang</th>
                            <th>Status</th>
                        </>
                    )}
                    {type === 'users' && (
                        <>
                            <th>Nama User</th>
                            <th>Email</th>
                            <th>Perusahaan</th>
                        </>
                    )}
                    {type === 'karyawan' && (
                        <>
                            <th>Nama Karyawan</th>
                            <th>Perusahaan</th>
                            <th>Email</th>
                            <th>No.HP</th>
                        </>
                    )}
                </tr>
                </thead>
                <tbody>
                {data.map((item, index) => (
                    <tr key={`${type}-${item.id || index}`}>
                        <td>{offset + index + 1}</td>
                        {type === 'perusahaan' && (
                            <>
                                <td>{item.perusahaan_nama || '-'}</td>
                                <td>{item.perusahaan_email || '-'}</td>
                                <td>{item.perusahaan_telp || '-'}</td>
                                <td>{item.perusahaan_no_wa || '-'}</td>
                                <td>{item.perusahaan_alamat || '-'}</td>
                                <td>{item.perusahaan_bidang || '-'}</td>
                                <td>{item.status || '-'}</td>
                            </>
                        )}
                        {type === 'users' && (
                            <>
                                <td>{item.p_user_name || '-'}</td>
                                <td>{item.p_user_email || '-'}</td>
                                <td>{item.perusahaan?.perusahaan_nama || '-'}</td>
                            </>
                        )}
                        {type === 'karyawan' && (
                            <>
                                <td>{item.karyawan_nama || '-'}</td>
                                <td>{item.perusahaan?.perusahaan_nama || '-'}</td>
                                <td>{item.karyawan_email || '-'}</td>
                                <td>{item.no_hp || '-'}</td>
                            </>
                        )}
                    </tr>
                ))}
                </tbody>
            </Table>
        );
    }

    render() {
        const { dataSearch, isLoading, keyword, activeTab, error, paging, currentPage, pageCount, initialLoad } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Daftar Pencarian Global" parent="Pencarian Global" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Pencarian Global</h5>
                        </div>
                        <div className="row p-3 align-items-end">
                            <div className="col-md-6">
                                <FormGroup className="mb-0">
                                    <Label style={{fontSize: "10px"}}>(Nama, Email, Bidang, No Telepon/WA)</Label>
                                    <Input
                                        type="text"
                                        name="keyword"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        value={keyword}
                                        onChange={this.handleChange}
                                        onKeyPress={this.handleKeyPress}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-2">
                                <FormGroup className="mb-0">
                                    <Label style={{fontSize: "10px"}}>Jumlah Data</Label>
                                    <Input
                                        type="select"
                                        name="paging"
                                        className="form-control-sm"
                                        value={paging}
                                        onChange={this.handlePaging}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div className="col-md-4 d-flex justify-content-start">
                                <ButtonGroup className="ms-2">
                                    <Button color="info" onClick={this.handleSearch} disabled={isLoading}>
                                        <FontAwesomeIcon icon={faSearch}/> Cari
                                    </Button>
                                    <Button color="dark" onClick={this.handleRefresh} disabled={isLoading}>
                                        <FontAwesomeIcon icon={faRetweet}/> Reset
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </div>

                        {error && <div className="alert alert-danger mx-3">{error}</div>}

                        <div className="card-body">
                            {isLoading ? (
                                <div className="text-center py-5">
                                    <Spin tip="Memuat hasil pencarian..." size="large"/>
                                </div>
                            ) : (
                                <>
                                    {!initialLoad && keyword.length === 0 && (
                                        <div className="alert alert-info mx-3">Menampilkan semua data</div>
                                    )}

                                    <ul className="nav nav-tabs mb-3">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                                                onClick={() => this.setState({ activeTab: 'all' })}
                                            >
                                                Semua
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'perusahaan' ? 'active' : ''}`}
                                                onClick={() => this.setState({ activeTab: 'perusahaan' })}
                                            >
                                                Perusahaan
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'users' ? 'active' : ''}`}
                                                onClick={() => this.setState({ activeTab: 'users' })}
                                            >
                                                Users
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'karyawan' ? 'active' : ''}`}
                                                onClick={() => this.setState({ activeTab: 'karyawan' })}
                                            >
                                                Karyawan
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="tab-content">
                                        {activeTab === 'all' && (
                                            <>
                                                <h5>Perusahaan</h5>
                                                {this.renderResults(dataSearch.perusahaan, 'perusahaan')}

                                                <h5 className="mt-4">Perusahaan User</h5>
                                                {this.renderResults(dataSearch.perusahaan_users, 'users')}

                                                <h5 className="mt-4">Karyawan</h5>
                                                {this.renderResults(dataSearch.karyawan, 'karyawan')}
                                            </>
                                        )}

                                        {activeTab === 'perusahaan' && this.renderResults(dataSearch.perusahaan, 'perusahaan')}
                                        {activeTab === 'users' && this.renderResults(dataSearch.perusahaan_users, 'users')}
                                        {activeTab === 'karyawan' && this.renderResults(dataSearch.karyawan, 'karyawan')}
                                    </div>

                                    {!isLoading && !initialLoad && keyword && pageCount === 0 && (
                                        <Empty description={`Tidak ditemukan hasil untuk "${keyword}"`} />
                                    )}
                                </>
                            )}
                        </div>

                        {pageCount > 1 && (
                            <div className="card-footer">
                                <Paging
                                    className="float-right"
                                    handlePageClick={this.handlePageClick}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}